export default "__VITE_ASSET__05763720__"